module.exports = __webpack_public_path__ + "img/chevron-right.cb01ceea.svg";